import { Data } from '@angular/router';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight',
})

export class HighlightPipe implements PipeTransform {
    public transform(data: Data[] = [], text: string, attribute: string) {
        const regex = new RegExp(text, 'i');

        data.map((element) => {
            if (regex.test(element[attribute])) {
                const texts = element[attribute].split(regex);

                element.highLight = texts.map((word, index) =>
                    (index < texts.length - 1) ? `${ word }<strong>${ text }</strong>` : word).join('');
            }
        });

        return data;
    }
}
